import { ProductOptionRangeModel } from "@vp/product-options-ui";
import { Ranges } from "@cimpress-technology/numeric-ranges";

export const mapMpvValueToProductOptionRangedChoice = (
  rangeInformation: Ranges
): ProductOptionRangeModel[] => {
  return rangeInformation.getRanges().map(range => ({
    minimum: range.getMinimum().toNumber(),
    maximum: range.getMaximum().toNumber(),
    increment: range.getIncrement()?.toNumber(),
  }));
};
